<div *ngIf="donor && !ticker_shown" class="d-flex ticker-wrapper align-items-center" @animateTickr>
  <!-- User image -->
  <div class="img-container">
    <img [attr.data-src]="donor?.image" default="/assets/images/default-campaign-picture.jpg" [alt]="donor?.name">
  </div>
  <!-- Monthly isgn up info -->
  <div class="sip-info">
    <strong>{{donor?.name}}</strong> {{iplocationObj?.city_name ? 'from '+iplocationObj?.city_name : ''}}
    <div> started contributing <app-currency-icon [currency]="donor?.currency"></app-currency-icon>{{donor?.amount}} monthly </div>
    <!-- <div class="signup-text"> just signed up for monthly giving</div> -->
  </div>
  <!-- Close button -->
  <div class="d-flex close-btn-container">
    <button mat-icon-button (click)="ticker_shown = true" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
